import { clsx } from 'clsx';
import { ReactElement } from 'react';
import { SkeletonImage } from '../SkeletonImage/SkeletonImage';
import { BankCode } from './banks.types';
import { Country } from '@axo/config/@types/Country.types';
import { bankName } from './bankName';
import { getPublicAssetUrl } from '../../../utils/getPublicAssetUrl';

import styles from './bank.module.scss';

export type BankProps = {
  code: BankCode;
  country: Omit<Country, 'GB'>;
  name?: string;
  isAlt?: boolean;
  className?: string;
} & HTMLDataAttributes;

/**
 * Bank component
 */
export const Bank = ({
  code = 'BN',
  country = 'SE',
  name,
  isAlt,
  className,
  ...props
}: BankProps): ReactElement => {
  const assetPath = `/partners/bank/${country.toLowerCase()}/${code}${
    isAlt ? '-alt' : ''
  }.svg`;

  return (
    <div className={clsx(styles.bank, className)} {...props}>
      <SkeletonImage
        src={getPublicAssetUrl(assetPath)}
        alt={name || bankName(String(country), code) || code}
        className={styles.image}
      />
    </div>
  );
};
